import React, {Fragment} from "react"

const BlockStyleFive = () => {
    return (
        <Fragment>
            <div className="block-style-five ps-xxl-5 ms-xxl-4">
                <h6 className="sub-title mb-20" data-aos="fade-up">Últimos Videos</h6>
                <h3 className="sect-title mb-20">La Mejor Agencia de Desarrollo de Software</h3>
                <p className="pe-xxl-5 mb-55">Estrategizamos continuamente ideas que cumplen con los estándares
                    en lugar de alineaciones basadas en rendimiento. Aprovechamos globalmente soluciones alternativas
                    existentes a través de usuarios virtuales.
                </p>
            </div>
        </Fragment>
    )
}

export default BlockStyleFive